export const getElementHeight = (className: string) => {
  const elem = document.querySelector(className);
  if (elem) return (elem as HTMLElement).offsetHeight;
  return 0;
};
